import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Jira Reverse Trial Popup Dialog.
 * Shown to Jira users in a reverse trial with an experience URL.
 */
export function isEligibleForReverseTrial(context: EditionAwarenessContextType): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInReverseTrial,
		addPaymentDetailsExperienceUrl,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
	} = context;

	return Boolean(
		!isInCollection &&
		isEditionOneOf(edition, ['premium']) &&
		product === 'jira' &&
		isInTrial &&
		isInReverseTrial &&
		addPaymentDetailsExperienceUrl &&
		invoiceableStatus === 'NOT_INVOICEABLE' &&
		canAddPaymentDetails,
	);
}
